module.exports = __webpack_public_path__ + "img/program-manekabe.2babd097.jpg";